import BaseEntityType from '@enums/BaseEntityType';
import EntityType from '@enums/EntityType';
import * as Colors from '@pkg/utils/colors';
import { core } from '@/lib/theme/tokens/palettes';

export default function entityColor(entityType) {
  const baseEntity = BaseEntityType[entityType];
  const color = Colors.entity(baseEntity || entityType);
  const colors = {
    normal: {
      backgroundColor: color.tints[1],
      color: color.main,
    },
    hover: {
      backgroundColor: color.tints[1],
      color: color.main,
    },
  };

  if (entityType === EntityType.ACTIVITY) {
    colors.normal = {
      backgroundColor: color.tints[1],
      color: color.shades[2],
    };
  }
  if (
    entityType === EntityType.ACTIVITY_TYPE ||
    entityType === EntityType.ACTIVITY_TAG ||
    entityType === EntityType.ACTIVITY_TAG_CATEGORY ||
    entityType === EntityType.ACTIVITY_PROPERTY ||
    entityType === EntityType.ACTIVITY_PROPERTY_VALUE
  ) {
    colors.normal = {
      backgroundColor: color.main,
      color: core.white,
    };
    colors.hover = {
      backgroundColor: color.shades[1],
      color: core.white,
    };
  }

  if (entityType === EntityType.HISTORICAL) {
    colors.normal = {
      backgroundColor: color.tints[4],
      color: color.shades[4],
    };
    colors.hover.backgroundColor = color.tints[1];
  }
  if (
    entityType === EntityType.GROUP_TAG ||
    entityType === EntityType.GROUP_TAG_CATEGORY ||
    entityType === EntityType.GROUP_PROPERTY ||
    entityType === EntityType.GROUP_PROPERTY_VALUE
  ) {
    colors.normal = {
      backgroundColor: color.main,
      color: core.white,
    };
    colors.hover = {
      backgroundColor: color.tints[1],
      color: core.white,
    };
  }

  if (entityType === EntityType.MANAGER) {
    colors.normal = {
      backgroundColor: color.tints[1],
      color: color.tints[6],
    };
    colors.hover.backgroundColor = color.tints[1];
  }

  if (entityType === EntityType.PERSON) {
    colors.normal = {
      backgroundColor: color.tints[0],
      color: color.tints[6],
    };
    colors.hover = {
      backgroundColor: color.tints[0],
      color: color.tints[6],
    };
  }
  if (
    entityType === EntityType.PERSON_SKILL ||
    entityType === EntityType.PERSON_SKILL_LEVEL
  ) {
    colors.normal = {
      backgroundColor: color.tints[5],
      color: core.white,
    };
    colors.hover = {
      backgroundColor: color.tints[5],
      color: core.white,
    };
  }

  if (entityType === EntityType.ROLE) {
    colors.hover.backgroundColor = color.tints[2];
  }
  if (
    entityType === EntityType.ROLE_PROPERTY ||
    entityType === EntityType.ROLE_PROPERTY_VALUE ||
    entityType === EntityType.ROLE_SKILL ||
    entityType === EntityType.ROLE_SKILL_LEVEL ||
    entityType === EntityType.ROLE_TAG ||
    entityType === EntityType.ROLE_TAG_CATEGORY ||
    entityType === EntityType.ROLE_TYPE
  ) {
    colors.normal = {
      backgroundColor: color.main,
      color: core.white,
    };
    colors.hover = {
      backgroundColor: color.tints[1],
      color: core.white,
    };
  }

  if (entityType === EntityType.SCENARIO) {
    colors.normal.color = color.shades[3];
    colors.hover.backgroundColor = color.tints[0];
  }

  if (entityType === EntityType.ORGANISATION) {
    colors.hover.backgroundColor = color.tints[2];
  }

  return colors;
}
